
import { Vue, Component } from 'vue-property-decorator';

/**
 * Component represent central circle which used in EMS, EnergyView...
 */
@Component
export default class CentralEndpoint extends Vue {}
